// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"364cffe6","354":"dc02a871","838":"d7e7e368"}[chunkId] + ".js";
};